import React from "react";

const renderErrorAsText = (error) => {
  if (typeof error === "string") return error;
  if (Array.isArray(error)) return error.map(renderErrorAsText).join(", ");
  if (error !== null && typeof error === "object") return JSON.stringify(error);
  return String(error);
};

const ValidationErrors = ({ errors, fieldErrors, debug }) => {
  if (!errors && !fieldErrors) return null;

  return (
    <div className="bg-red-50 border border-red-200 rounded-md p-4 mb-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg
            className="h-5 w-5 text-red-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            Validation Failed
          </h3>
          <div className="mt-2 text-sm text-red-700">
            {/* Field-specific errors */}
            {fieldErrors && Object.keys(fieldErrors).length > 0 && (
              <div className="space-y-2">
                {Object.entries(fieldErrors).map(([field, fieldErrorList]) => (
                  <div key={field}>
                    <div className="font-medium capitalize">
                      {field.replace(/_/g, " ").replace(/([A-Z])/g, " $1")}:
                    </div>
                    <ul className="list-disc list-inside ml-4 space-y-1">
                      {fieldErrorList.map((error, index) => (
                        <li key={index}>{renderErrorAsText(error)}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            )}

            {/* General errors if no field-specific errors */}
            {(!fieldErrors || Object.keys(fieldErrors).length === 0) &&
              errors && (
                <ul className="list-disc list-inside space-y-1">
                  {errors.map((error, index) => (
                    <li key={index}>
                      <span className="font-medium">
                        {error.path || error.param}:
                      </span>{" "}
                      {error.msg}
                    </li>
                  ))}
                </ul>
              )}
          </div>

          {/* Debug information in development */}
          {debug && process.env.NODE_ENV === "development" && (
            <details className="mt-3">
              <summary className="text-xs text-red-600 cursor-pointer">
                Debug Info
              </summary>
              <div className="mt-2 text-xs text-red-600 bg-red-100 p-2 rounded">
                <div>
                  <strong>Received Fields:</strong>{" "}
                  {debug.receivedFields?.join(", ")}
                </div>
                <div>
                  <strong>Required Fields:</strong>{" "}
                  {debug.requiredFields?.join(", ")}
                </div>
                {debug.bodyData && (
                  <div className="mt-2">
                    <strong>Form Data:</strong>
                    <pre className="text-xs overflow-x-auto">
                      {JSON.stringify(debug.bodyData, null, 2)}
                    </pre>
                  </div>
                )}
              </div>
            </details>
          )}
        </div>
      </div>
    </div>
  );
};

export default ValidationErrors;
